import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, connect } from 'react-redux'
import AddContract from './add'
import AddPendingUniContract from './addPendingUni'
import { TableComp } from 'sz-react-utils-lite'
import {
  displayDate
} from '../../../components/_utils/appUtils'
import {
  listAllPendingContractFxn
} from '../actions/contract'
import { Icon, Tooltip } from 'antd'

const universityTypeList = [
  { name: 'Already Added in Portal', value: 'alreadyAdded' },
  { name: 'Not Added in Portal', value: 'other' }
]

const PendingUniversityContract = (props) => {
  const tableRef = useRef()
  const dispatch = useDispatch()
  let [totalRecord, setTotalRecord] = useState(0)
  const [itemNo, setItemNo] = useState(1)
  const [addContractVisible, setAddContractVisible] = useState(false)
  const [pendingUniDrawer, setPendingUniDrawer] = useState(false)
  const [contractId, setContractId] = useState('')
  const [pendingContractData, setPendingContractData] = useState()


  const events = {
    hideDrawer: () => {
      setAddContractVisible(false)
      tableRef.current.reload()
    },
    hidePendingUniDrawer: () => {
      setPendingUniDrawer(false)
      tableRef.current.reload()
    }
  }
  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let respData = await dispatch(listAllPendingContractFxn({
        ...params
      }))
      setTotalRecord(respData.total)
      resolve(respData)
    })
  }


  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      width: 50,
      key: 'sno',
      render: (item, record, index) => {
        return (
          <a className={'linkPointer'}>
            {(itemNo - 1) * 10 + index + 1}
          </a>
        )
      }
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      width: 120,
      render: (item) => {
        return (
          <div className={'alignCenter'}>
            {item == 'Pending' ?
              <div className={'label label-warning'}>
                {item}
              </div> :
              <div className={'label label-success'}>
                {item}
              </div>
            }
          </div>
        )
      }
    },
    {
      title: 'Country',
      dataIndex: 'countryId',
      key: 'countryId',
      width: 150,
      render: (item) => {
        return (
          item && item.countryName ? item.countryName : ''
        )
      }
    },
    {
      title: 'University',
      dataIndex: 'universityType',
      key: 'universityType',
      width: 300,
      render: (item, record) => {
        let { universityId, universityName } = record
        return (
          <div>
            {item == 'alreadyAdded' && universityId && universityId.universityName ? universityId.universityName : null}
            {item == 'other' && universityName ? universityName : null}
          </div>
        )
      }
    },
    {
      title: 'university City',
      key: 'universityCity',
      dataIndex: 'universityCity',
      width: 200
    },
    {
      title: 'Expected Date',
      dataIndex: 'expectedDate',
      key: 'expectedDate',
      width: 120,
      render: (item) => {
        return (
          item ? displayDate(item) : ''
        )
      }
    },
    {
      title: 'Details',
      key: 'details',
      dataIndex: 'details'
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      width: 115,
      render: (_, record) => {
        let { status } = record
        return (
          <>
            {status == 'Pending' ?
              <Tooltip title='Convert Contract'>
                <a className={'btn btn-default roundNew aic jcc sm'} onClick={() => {
                  setAddContractVisible(true)
                  setContractId(record._id)
                  setPendingContractData(record)
                }}>
                  <Icon type={'reload'} style={{ fontSize: 11 }} />Convert
                </a>
              </Tooltip> : null}
          </>
        )
      }
    }
  ]

  return (
    <div className='row mt-4'>
      <div className='col-lg-12'>
        <div className='card reportContainer'>
          <div className='table-head d-flex align-items-center'>
            <h5>All Pending University Contract: ({totalRecord})</h5>
            <div className='search-box-table'>
            </div>
            <div className='sort-box-table mark-btn'>
              <button
                className='btn'
                onClick={() => setPendingUniDrawer(true)}
              >
                <img src={'../dist/icons/plus.png'} className={'plus'} />
                Add Pending University Contract
              </button>
            </div>
          </div>
          <div className='card-body table-responsive'>
            <TableComp columns={columns}
                       apiRequest={apiRequest}
                       ref={tableRef}
            />
          </div>
        </div>
      </div>
      {addContractVisible ?
        <AddContract
          data={pendingContractData}
          visible={addContractVisible}
          universityTypeList={universityTypeList}
          events={events}
        /> : ''}
      {pendingUniDrawer ?
        <AddPendingUniContract
          visible={pendingUniDrawer}
          universityTypeList={universityTypeList}
          events={events}
          id={contractId}
        /> : ''}
    </div>
  )
}
export default connect(
)(PendingUniversityContract)
